import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StudentTable } from './StudentTable';
import { StudentDetailPanel } from './StudentDetailPanel';
import { AppState, ModuleId } from '../../types';
import { GroupId } from '../../config/systemConfig';
interface StudentData {
  id: string;
  name: string;
  data: AppState;
}
interface TeacherStudentsTabProps {
  students: StudentData[];
  selectedGroup: GroupId;
  getModuleMastery: (learnerId: string, moduleId: ModuleId) => number;
  viewingLearnerId: string | null;
  onSelectStudent: (studentId: string) => void;
  onNavigateToLearner?: (learnerId: string) => void;
}
export function TeacherStudentsTab({
  students,
  selectedGroup,
  getModuleMastery,
  viewingLearnerId,
  onSelectStudent,
  onNavigateToLearner
}: TeacherStudentsTabProps) {
  const [detailStudentId, setDetailStudentId] = useState<string | null>(null);
  const detailStudent = detailStudentId ? students.find(s => s.id === detailStudentId) : null;
  return <div className="flex flex-col xl:flex-row gap-6 items-start" data-id="element-5571">
      <div className={`flex-1 w-full transition-all duration-300 ${detailStudent ? 'xl:w-2/3' : 'w-full'}`} data-id="element-5572">
        <StudentTable students={students} selectedGroup={selectedGroup} getModuleMastery={getModuleMastery} selectedStudentId={viewingLearnerId} onSelectStudent={onSelectStudent} onViewDetails={id => setDetailStudentId(id)} data-id="element-5573" />
      </div>

      <AnimatePresence data-id="element-5574">
        {detailStudent && <motion.div initial={{
        opacity: 0,
        x: 20,
        width: 0
      }} animate={{
        opacity: 1,
        x: 0,
        width: 'auto'
      }} exit={{
        opacity: 0,
        x: 20,
        width: 0
      }} className="w-full xl:w-1/3 flex-shrink-0" data-id="element-5575">
            <StudentDetailPanel student={detailStudent} selectedGroup={selectedGroup} getModuleMastery={getModuleMastery} onClose={() => setDetailStudentId(null)} onViewDashboard={onNavigateToLearner} data-id="element-5576" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}